import React from 'react';
import AppConstants from 'AppConstants';
import axios from 'axios';
import Page from 'components/Page';
import {
    Row,
    Col,
    Card,
    CardBody,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Alert,
  } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Loading from 'assets/img/loader.gif';
import {ReactTitle} from 'react-meta-tags';
import DatePicker from "react-datepicker";
import { MdDateRange } from 'react-icons/md';
import SearchableSelect from './searchableSelect';

const MAX_MESSAGE_LENGTH = 500;
const SLOT_MINUTES = 15;

const roleOptions = [
    { value: 'student', label: 'Students' },
    { value: 'parent', label: 'Parents' },
    { value: 'participant', label: 'Participants' }
];

const selectedRoleLabels = (roles) => roleOptions.filter(role => roles.indexOf(role.value) != -1).map(role => role.label).join(', ');

// A resource's "User type" values (set when the resource is created) as shown in the admin
const resourceUserTypeLabels = { Student: 'Students', Parent: 'Parents', Mentor: 'Participants' };
export const formatResourceUserTypes = (userTypes) => ['Student', 'Parent', 'Mentor']
    .filter(type => (userTypes || []).indexOf(type) != -1)
    .map(type => resourceUserTypeLabels[type]).join(', ');

// Every 15 minute slot of a day as minutes after midnight: 0, 15, 30 ... 1425
const timeSlots = Array.from({ length: (24 * 60) / SLOT_MINUTES }, (v, i) => i * SLOT_MINUTES);

const formatSlot = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const suffix = hours < 12 ? 'AM' : 'PM';
    const displayHours = hours % 12 == 0 ? 12 : hours % 12;
    return displayHours + ':' + (mins < 10 ? '0' + mins : mins) + ' ' + suffix;
};

const isSameDay = (a, b) => a.getFullYear() == b.getFullYear() && a.getMonth() == b.getMonth() && a.getDate() == b.getDate();

// Scheduled date in the admin's browser timezone
const buildScheduledDate = (date, minutes) => new Date(date.getFullYear(), date.getMonth(), date.getDate(), Math.floor(minutes / 60), minutes % 60, 0, 0);

class AddPushNotification extends React.Component{
    constructor(){
        super();
        this.state = {
            errors: {},
            message: '',
            resource_id: '',
            resources: [],
            resources_loaded: false,
            resources_loading: false,
            roles: [],
            send_type: 'immediate',
            schedule_date: null,
            schedule_time: '',
            loading: '',
            errMsg: ''
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    // Resources every selected user type can access (a resource's "User type" must include all of them)
    loadResources(roles){
        const request = (this.resourcesRequest || 0) + 1;
        this.resourcesRequest = request;
        if(roles.length == 0){
            this.setState({ resources: [], resources_loaded: false, resources_loading: false, resource_id: '' });
            return;
        }
        this.setState({ resources_loading: true });
        axios.get(AppConstants.API+'/pushNotifications/getResources', { params: { roles: roles.join(',') } })
        .then(res => {
            // Ignore an older request that finished after a newer one
            if(request != this.resourcesRequest) return;
            const resources = res.data.Status == "Success" ? res.data.data : [];
            // Clear the chosen resource if the new user types can't all access it
            const stillAvailable = resources.some(resource => resource._id == this.state.resource_id);
            this.setState({
                resources: resources,
                resources_loaded: true,
                resources_loading: false,
                resource_id: stillAvailable ? this.state.resource_id : ''
            });
        })
        .catch(() => {
            if(request != this.resourcesRequest) return;
            this.setState({ resources: [], resources_loaded: true, resources_loading: false, resource_id: '' });
        });
    }
    handleResourceChange = (resourceId) => {
        this.setState({ resource_id: resourceId });
    }
    handleMessageChange = (e) => {
        this.setState({ message: e.target.value.slice(0, MAX_MESSAGE_LENGTH) });
    }
    handleRoleChange = (role) => (e) => {
        // Keep the same order as the checkboxes
        const roles = roleOptions.map(option => option.value).filter(value =>
            value == role ? e.target.checked : this.state.roles.indexOf(value) != -1
        );
        this.setState({ roles: roles });
        this.loadResources(roles);
    }
    handleSendTypeChange = (e) => {
        this.setState({ send_type: e.target.value });
    }
    handleDateChange = (date) => {
        this.setState({ schedule_date: date });
        // Clear a time that is no longer available on the new date
        if(date && this.state.schedule_time !== '' && this.getAvailableSlots(date).indexOf(Number(this.state.schedule_time)) == -1){
            this.setState({ schedule_time: '' });
        }
    }
    handleTimeChange = (e) => {
        this.setState({ schedule_time: e.target.value });
    }
    openDatepicker(){
        this._calendar.setOpen(true);
    }
    getAvailableSlots(date){
        if(!date) return timeSlots;
        const now = new Date();
        if(!isSameDay(date, now)) return timeSlots;
        // Today: only slots that have not started yet
        const nowMinutes = now.getHours() * 60 + now.getMinutes();
        return timeSlots.filter(slot => slot > nowMinutes);
    }
    handleValidation(){
        let errors = {};
        let formIsValid = true;
        if(!this.state.resource_id){
            formIsValid = false;
            errors["resource_id"] = "Please select a resource";
        }
        if(!this.state.message.trim()){
            formIsValid = false;
            errors["message"] = "Please enter a message";
        }
        if(this.state.roles.length == 0){
            formIsValid = false;
            errors["roles"] = "Please select at least one role";
        }
        if(this.state.send_type == 'scheduled'){
            if(!this.state.schedule_date){
                formIsValid = false;
                errors["schedule_date"] = "Please select a date";
            }
            if(this.state.schedule_time === ''){
                formIsValid = false;
                errors["schedule_time"] = "Please select a time";
            }
            if(this.state.schedule_date && this.state.schedule_time !== '' &&
                buildScheduledDate(this.state.schedule_date, Number(this.state.schedule_time)) <= new Date()){
                formIsValid = false;
                errors["schedule_time"] = "Please select a time in the future";
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleSubmit(e){
        e.preventDefault();
        if(!this.handleValidation() || this.state.loading) return;
        this.setState({ loading: 1, errMsg: '' });
        const formval = {
            message: this.state.message.trim(),
            resource_id: this.state.resource_id,
            roles: this.state.roles,
            send_type: this.state.send_type,
            admin_id: this.props.auth.user._id
        };
        if(this.state.send_type == 'scheduled'){
            formval.scheduled_date = buildScheduledDate(this.state.schedule_date, Number(this.state.schedule_time)).toISOString();
        }
        axios.post(AppConstants.API+'/pushNotifications/createPushNotification', formval)
        .then(res => {
            if(res.data.Status == "Success"){
                this.setState({
                    loading: '',
                    errMsg: (<div className="alert alert-success fade show mt-3">{res.data.msg}</div>),
                });
                setTimeout(() => {
                    this.props.history.push('/pushNotifications');
                }, 1500);
            }else{
                this.setState({
                    loading: '',
                    errMsg: (<div className="alert alert-danger fade show mt-3">{res.data.msg}</div>),
                });
            }
        })
        .catch(() => {
            this.setState({
                loading: '',
                errMsg: (<div className="alert alert-danger fade show mt-3">Problem while sending the data</div>),
            });
        });
    }
    render(){
        const availableSlots = this.getAvailableSlots(this.state.schedule_date);
        const selectedResource = this.state.resources.find(resource => resource._id == this.state.resource_id);
        return(
            <Page className="cms-edit" title="New Push Notification">
            <ReactTitle title="New Push Notification"/>
            <ul className="cst-breadcrumb">
               <li><Link to={'/dashboard'}>Home</Link> </li>
               <li>  <Link to={'/pushNotifications'}>  Push Notifications </Link> </li>
               <li> New Notification</li>
             </ul>
           <Row>
             <Col xl={12} lg={12} md={12}>
               <Card>
                 <CardBody>
                   <Form name="addPushNotification" onSubmit= { this.handleSubmit }>
                     <Alert color="info" className="mb-4">
                       <strong>Who receives this notification</strong>
                       <ul className="mb-0 pl-3 mt-1">
                         <li>Select <strong>Send To</strong> first. Only resources whose <strong>User type</strong> includes <strong>every</strong> selected user type are listed (for example, Students + Parents shows only resources available to both).</li>
                         <li>Users whose user type has no access to the resource never receive it. For scheduled notifications this is checked again at send time, in case the resource's User type changed.</li>
                       </ul>
                     </Alert>
                     <FormGroup row>
                       <Label sm={2}>
                       Send To <span style={{color: 'red'}}> * </span>
                       </Label>
                       <Col sm={10} className="pt-2">
                         {roleOptions.map(role => (
                           <FormGroup check inline key={role.value}>
                             <Label check>
                               <Input
                                 type="checkbox"
                                 checked={this.state.roles.indexOf(role.value) != -1}
                                 onChange={this.handleRoleChange(role.value)}
                               />{' '}{role.label}
                             </Label>
                           </FormGroup>
                         ))}
                         <div><span className="error" style={{color: 'red'}}>{this.state.errors["roles"]}</span></div>
                       </Col>
                     </FormGroup>
                     <FormGroup row>
                       <Label for="resource_id" sm={2}>
                       Resource <span style={{color: 'red'}}> * </span>
                       </Label>
                       <Col sm={10}>
                         <SearchableSelect
                           options={this.state.resources.map(resource => ({ value: resource._id, label: resource.title }))}
                           value={this.state.resource_id}
                           onChange={ this.handleResourceChange }
                           disabled={this.state.roles.length == 0 || this.state.resources_loading}
                           placeholder={this.state.roles.length == 0 ? 'Select "Send To" first'
                             : this.state.resources_loading ? 'Loading resources...' : 'Search or select resource'}
                           emptyText="No resources match your search"
                         />
                         {this.state.roles.length > 0 && !this.state.resources_loading
                           ? <small className="text-muted">
                               {this.state.resources_loaded && this.state.resources.length == 0
                                 ? 'No active resources are available to all of: ' + selectedRoleLabels(this.state.roles) + '. Change "Send To" or update the resource\'s User type.'
                                 : 'Showing resources available to all of: ' + selectedRoleLabels(this.state.roles)}
                             </small>
                           : ''}
                         {selectedResource &&
                           <div className="mt-1">
                             <small><strong>Available to:</strong> {formatResourceUserTypes(selectedResource.user_type) || '-'}</small>
                           </div>}
                         <div><span className="error" style={{color: 'red'}}>{this.state.errors["resource_id"]}</span></div>
                       </Col>
                     </FormGroup>
                     <FormGroup row>
                       <Label for="message" sm={2}>
                       Message <span style={{color: 'red'}}> * </span>
                       </Label>
                       <Col sm={10}>
                         <Input
                           type="textarea"
                           name="message"
                           rows={4}
                           placeholder="Message"
                           value={this.state.message}
                           onChange={ this.handleMessageChange }
                         />
                         <small className="text-muted">{this.state.message.length}/{MAX_MESSAGE_LENGTH}</small>
                         <div><span className="error" style={{color: 'red'}}>{this.state.errors["message"]}</span></div>
                       </Col>
                     </FormGroup>
                     <FormGroup row>
                       <Label sm={2}>
                       When <span style={{color: 'red'}}> * </span>
                       </Label>
                       <Col sm={10} className="pt-2">
                         <FormGroup check inline>
                           <Label check>
                             <Input type="radio" name="send_type" value="immediate" checked={this.state.send_type == 'immediate'} onChange={this.handleSendTypeChange} />{' '}Send now
                           </Label>
                         </FormGroup>
                         <FormGroup check inline>
                           <Label check>
                             <Input type="radio" name="send_type" value="scheduled" checked={this.state.send_type == 'scheduled'} onChange={this.handleSendTypeChange} />{' '}Schedule
                           </Label>
                         </FormGroup>
                       </Col>
                     </FormGroup>
                     {this.state.send_type == 'scheduled' &&
                     <FormGroup row>
                       <Label sm={2}>
                       Schedule Date &amp; Time <span style={{color: 'red'}}> * </span>
                       </Label>
                       <Col sm={5}>
                          <div className="cst-date-picker">
                          <DatePicker
                              name="schedule_date"
                              className="form-control"
                              placeholderText="MM-DD-YYYY"
                              selected={this.state.schedule_date}
                              onChange={this.handleDateChange}
                              dateFormat="MM-dd-yyyy"
                              minDate={new Date()}
                              autoComplete="off"
                              onKeyDown={(e) => e.preventDefault()}
                              ref={(c) => this._calendar = c}
                          />
                          <MdDateRange className="cale-icon" onClick={this.openDatepicker.bind(this)}/>
                          </div>
                          <span className="error" style={{color: 'red'}}>{this.state.errors["schedule_date"]}</span>
                       </Col>
                       <Col sm={5}>
                          <Input type="select" name="schedule_time" value={this.state.schedule_time} onChange={this.handleTimeChange}>
                            <option value="">Select time</option>
                            {availableSlots.map(slot => (
                              <option key={slot} value={slot}>{formatSlot(slot)}</option>
                            ))}
                          </Input>
                          {this.state.schedule_date && availableSlots.length == 0 ? <small className="text-muted">No times left today, please pick another date</small> : ''}
                          <div><span className="error" style={{color: 'red'}}>{this.state.errors["schedule_time"]}</span></div>
                       </Col>
                     </FormGroup>
                     }
                     <FormGroup check row>
                       <Col sm={{ size: 10, offset: 2 }}>
                         <Button className="btn btn-primary" disabled={!!this.state.loading} onClick={ this.handleSubmit }>{this.state.send_type == 'scheduled' ? 'Schedule' : 'Send'}
                             <div style={this.state.loading ? {} : { display: 'none' }} className="image-fill w-25 loader-div "><img src={Loading} alt="No Image" className="can-click " /></div>
                         </Button>&nbsp;
                         <Link to={"/pushNotifications"} className="btn btn-danger" title="Cancel">&nbsp;Cancel</Link>
                       </Col>
                     </FormGroup>
                     {this.state.errMsg}
                   </Form>
                 </CardBody>
               </Card>
             </Col>
           </Row>
         </Page>
        )
    }
}
const mapStateToProps = (state) => ({
    auth: state.auth
});
export default connect(mapStateToProps, {})(AddPushNotification);
